module.exports = __webpack_public_path__ + "static/media/Calendar.9b12b06c.svg";